import React from 'react';
import ProductCardView from './ProductCard.view';
import { ProductItemProps } from '../ProductList';

const ProductCard = ({
  product,
  setProductQuantity,
  onAddToCart,
  onClickNavigate,
  isPublicShop
}: ProductItemProps) => {
  return (
    <ProductCardView
      onClick={onClickNavigate}
      product={product}
      onAddToCart={onAddToCart}
      setProductQuantity={setProductQuantity}
      isOut={product.isOut}
      isPublicShop={isPublicShop}
    />
  );
};

export default React.memo(ProductCard);
